import {
  Button,
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

// `kind` is "field" or "owner".
export default function ConfirmDeleteDialog({
  kind = "field",
  elementId,
  handleConfirmDelete,
  isDialogOpen,
  handleOnClose,
  deleting,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={handleOnClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t("deleteDialog.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            <Trans
              i18nKey={`deleteDialog.${kind}`}
              values={{ name: elementId }}
              components={{ strong: <strong /> }}
            />
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOnClose} color="inherit">
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            disabled={deleting}
          >
            {deleting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("common.delete")
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
